import { Component, OnInit } from '@angular/core';
import { Utils } from './../../../common/utils';
import { MessageService, ConfirmationService, SelectItem } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormGroup, FormControl, Validators } from '@angular/forms';
import { FechasService } from 'src/app/services/fechas/fechas';
import { GenericService } from 'src/app/services/generic/generic.service';

@Component({
  selector: 'app-clientes-list',
  templateUrl: './clientes-list.component.html',
  styleUrls: ['./clientes-list.component.css']
})
export class ClientesListComponent implements OnInit {

  public cols = [
    { header: 'Opciones', field: 'opciones'},
    { header: 'Nombre', field: 'nombre'},
    { header: 'Cif', field: 'cif',width: '100px'},
    { header: 'Direccion', field: 'direccion'},    
    { header: 'CP', field: 'cp', width:'80px'},    
    { header: 'Localidad', field: 'localidad'},
    { header: 'Provincia', field: 'provincia'}, 
    { header: 'País', field: 'pais'}, 
    { header: 'Departamento', field: 'departamento'}, 
    { header: 'Persona contacto', field: 'persona_contacto'}, 
    { header: 'Teléfono', field: 'telefono', width:'100px'},
    { header: 'Email', field: 'email'},
    { header: 'Tipo precio facturación', field: 'tipo_precio_facturacion'},    
    { header: 'Condición', field: 'condicion'},    
    { header: 'Precio/cc transporte', field: 'precio_cc_transporte', width:'100px'},    
    { header: 'Precio camión completo', field: 'precio_camion_completo', width:'100px'},    
    { header: 'Título campo artículo', field: 'titulo_campo_articulo'},    
  ];

  public es = Utils.es;
  public date2: Date;
  public expression = false;
  public title = "Clientes";
  public control: any = [];
  public TransporteData: any = [];
  public displayDialog = false;
  public editControl: any = [];
  public mostrar = false;
  public display: boolean = false;
  public createControlForm: UntypedFormGroup;
  public myMonth = "";
  public database = "clientes";
  public database_origen = "clientes";

  public selectedOpciones: string = "";
  public oldValue: string = "";
  public columnasVisibles: boolean = false;
  public showInfo: boolean = true;
  public showDuplicate: boolean = true;
  public opciones: SelectItem[];

  public selectedColumns: any[];
  public anchoTabla = "1500px";
  public showTables: boolean = true;
  public listarTodos: boolean = true;
  public mostrarInformes: boolean = true;
  public displayMultiple: any;  

  constructor(
    private genericService: GenericService,
    private messageService: MessageService,
    private router: Router,
    private route: ActivatedRoute,
    private fechaService: FechasService,
    private confirmationService: ConfirmationService) {

    this.showCols();

  }

  ngOnInit(): void {

    this.iniciar();

  }

  iniciar() {
    this.mostrar = false;
    this.genericService.getListSimple( this.database,'nombre').toPromise().then((data: any) => {
      
      
      this.control = data.productos;
      this.mostarTabla();
      
    }).catch(error => {
      console.log("Error", error);
    });
  }

  listarCampos() {

    if (this.showTables) {
      this.showTables = false;
      this.columnasTotales();


    } else {
      this.showTables = true;
      this.columnasSimples();

    }
  }


  showCols(){

      this.columnasVisibles = false;
      this.anchoTabla = "1500px";
      this.selectedColumns = this.cols;
    
  }


  mostarTabla() {
    this.mostrar = true;
  }

  columnasSimples() {
    this.columnasVisibles = false;
    this.anchoTabla = "1500px";
    this.selectedColumns = this.cols;
  }
  columnasTotales() {
    this.columnasVisibles = false;
    this.anchoTabla = "4000px";
    this.selectedColumns = this.cols;
  }

  delete(id) {
    this.confirmationService.confirm({
      header: 'Confirmación',
      acceptLabel: 'Acceptar',
      rejectLabel: 'Cancelar',
      message: 'Quieres eliminar este registro?',
      accept: () => {

        this.genericService.delete( id, this.database_origen ).subscribe(data => {
          this.iniciar();
        }, error => {
          console.error("error ", error);
        });
      }
    });

  }


  cerrar() {
    this.display = false;

    this.expression = false;
  }

  closeWindow(event) {
    this.cerrar();
  }

 


  duplicate(transporte) {
    let newId = "";
    this.genericService.clone(transporte.id, this.database_origen).toPromise().then((data:any) => {
     
      newId = data.id;

      this.messageService.add({ severity: 'success', summary: `Registro ${this.database_origen}`, detail: `Registro ${this.database_origen} Duplicado` });
      this.iniciar();
    }).catch(error => {
      this.messageService.add({ severity: 'error', summary: `Registro ${this.database_origen}`, detail: `Error en registro ${this.database_origen}` });
      console.log("error", error);
    });

  }

  arreglarfecha(fecha) {

    let arregloFecha = fecha.split("/");

    let myfecha = "";

    // console.log(myfecha);
    myfecha = arregloFecha[2] + "-" + arregloFecha[1] + "-" + arregloFecha[0];
    return myfecha;
  }


  public mydt: any;
  closeWindowMultpile(event) {
    this.consultar();
  }

  cambios(dt) {

    this.mydt = dt;

  }
  consultar() {

    if (this.displayMultiple) {
      this.displayMultiple = false;
    } else {
      this.displayMultiple = true;
    }
    if (this.mydt == null || this.mydt == undefined || this.mydt == 'object' || this.mydt.length == 0) {

    } else if (this.mydt.filteredValue == null || this.mydt == undefined) {

    } else {

    }
  }

}
